// extracted by mini-css-extract-plugin
module.exports = {"btn-input-wrapper":"styles_btn-input-wrapper__4ZsYH","btn-input":"styles_btn-input__3gvBz","input-btn":"styles_input-btn__aW56D"};